import PropTypes from 'prop-types';
import React from 'react';
import IconButton from './IconButton';
import Icon from './Icon';
import { getComponentClasses } from '@99designs/utils/app';
import CSSTransitionGroup from 'react-transition-group/CSSTransitionGroup';

export default class InfoBox extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            isDismissed: props.defaultDismissed,
        };
        this.dismiss = this.dismiss.bind(this);
    }

    dismiss() {
        this.setState({
            isDismissed: true,
        });

        this.props.onDismiss();
    }

    render() {
        return (
            <CSSTransitionGroup
                transitionName={{
                    leave: 'info-box-dismiss',
                    leaveActive: 'info-box-dismiss--active',
                }}
                transitionEnterTimeout={0}
                transitionLeaveTimeout={250}
            >
                {this.infoBox()}
            </CSSTransitionGroup>
        );
    }

    infoBox() {
        if (this.state.isDismissed) {
            return;
        }

        const classes = getComponentClasses('info-box', this.props.variations);
        return (
            <div key="info-box-dismiss">
                <div className={classes}>
                    {this.title()}
                    {this.dismissButton()}
                    <div className="info-box__content">{this.props.children}</div>
                </div>
            </div>
        );
    }

    dismissButton() {
        if (!this.props.isDismissable) {
            return null;
        }

        return (
            <div className="info-box__dismiss">
                <IconButton onClick={this.dismiss}>
                    <Icon variations={['x-3']} />
                </IconButton>
            </div>
        );
    }

    title() {
        if (this.props.title) {
            return <div className="info-box__title">{this.props.title}</div>;
        }
    }
}

InfoBox.propTypes = {
    title: PropTypes.node,
    children: PropTypes.node.isRequired,
    isDismissable: PropTypes.bool,
    defaultDismissed: PropTypes.bool,
    onDismiss: PropTypes.func,
    variations: PropTypes.array,
};

InfoBox.defaultProps = {
    onDismiss: () => {},
    isDismissable: true,
    defaultDismissed: false,
    variations: [],
};



// WEBPACK FOOTER //
// ./~/@99designs/react-components/components/InfoBox.jsx